<template>
  <footer>
    <div class="ser-twrap">
      <div class="tit">
        <div class="contact-info desktop-only">
          全国服务热线：<i>{{ settings.contactNumber }}</i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为您提供更多服务，尽在 &nbsp;&nbsp;<span>{{ settings.domesticUrl }}</span>
        </div>
        <div class="contact-info mobile-only">
          <div>全国服务热线：<i>{{ settings.contactNumber }}</i></div>
          <div>为您提供更多服务，尽在 <span>{{ settings.domesticUrl }}</span></div>
        </div>
      </div>
    </div>
    <div class="fot">
      <ul class="text-center">
        <li>
          <a class="box" id="fkVideoPreBox" title="品牌视频" @click.prevent="toggleVideoModal(true)">
            <img src="/images/s1.svg" alt="品牌视频">
            <div class="d1">品牌视频</div>
            <div class="d2"><span>点击查看品牌视频</span></div>
          </a>
        </li>
        <li>
          <router-link class="box" to="/service" title="服务与支持">
            <img src="/images/s4.svg" alt="服务与支持">
            <div class="d1">服务与支持</div>
            <div class="d2"><span>用心为您提供售后服务</span></div>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="fwrap">
      <div class="uk-container">
        <div class="footer-sitemap">
          <div class="sitemap-column">
            <h3>关于我们</h3>
            <ul>
              <li><router-link to="/about">公司简介</router-link></li>
              <li><router-link to="/news">新闻资讯</router-link></li>
              <li><router-link to="/contact">联系我们</router-link></li>
            </ul>
          </div>
          <div class="sitemap-column">
            <h3>产品中心</h3>
            <ul>
              <li v-for="cat in productCategories" :key="cat.id">
                <router-link :to="`/product_list/${cat.id}`">{{ cat.name }}</router-link>
              </li>
            </ul>
          </div>
          <div class="sitemap-column">
            <h3>解决方案</h3>
            <ul>
              <li v-for="cat in caseCategories" :key="cat.id">
                <router-link :to="`/solutions?category=${cat.id}`">{{ cat.name }}</router-link>
              </li>
            </ul>
          </div>
          <div class="sitemap-column">
            <h3>服务与支持</h3>
            <ul>
              <li><router-link to="/service">服务政策</router-link></li>
              <li><router-link to="/service?tab=faq">常见问题</router-link></li>
              <li><router-link to="/service?tab=complaints">投诉建议</router-link></li>
            </ul>
          </div>
          <div class="sitemap-column">
            <h3>友情链接</h3>
            <ul>
              <li><a class="hand-cursor" @click="openExternalLink(settings.overseasUrl)" target="_blank">海外官网</a></li>
            </ul>
          </div>
        </div>
        <div class="foot-f uk-clearfix">
          <div class="f2 f-cb uk-clearfix">
            <span class="des fl">{{ settings.copyright }}</span>
            <span class="fr tel">
              <span class="cn">全国服务热线</span>
              <svg t="1748195647832" class="icon" viewBox="0 0 1066 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1622" width="200" height="200">
                <path d="M548.48 0c282.752 0 512 229.248 512 512s-229.248 512-512 512c-282.794667 0-512-229.248-512-512s229.205333-512 512-512z m0 42.666667c-259.242667 0-469.333333 210.133333-469.333333 469.333333s210.090667 469.333333 469.333333 469.333333c259.2 0 469.333333-210.133333 469.333333-469.333333s-210.133333-469.333333-469.333333-469.333333zM375.594667 236.544c9.514667 0.597333 22.613333 4.266667 34.474666 20.778667 16.042667 21.418667 34.474667 53.162667 49.92 87.424 16.085333 35.413333-1.749333 51.328-18.986666 66.005333l-0.597334 0.597333s-31.530667 23.850667-36.864 27.52a13.525333 13.525333 0 0 0-3.584 17.706667c24.405333 40.32 55.893333 80.64 92.757334 116.138667a625.408 625.408 0 0 0 115.328 89.216c2.986667 1.237333 5.973333 2.432 9.514666 1.237333h1.194667a11.733333 11.733333 0 0 0 7.722667-7.338667c3.584-8.533333 9.514667-20.181333 16.085333-30.549333 13.056-20.181333 25.557333-31.146667 39.808-34.261333 4.181333-1.194667 7.722667-1.194667 11.306667-1.194667 3.584 0 10.112 1.194667 17.237333 4.266667 1.792 0.597333 42.24 15.274667 74.922667 36.693333 12.501333 7.936 33.28 21.973333 37.461333 42.752 2.986667 14.08-1.792 30.592-13.653333 49.493333a142.677333 142.677333 0 0 1-85.632 60.544c-14.890667 3.669333-31.530667 4.864-48.170667 3.669334a207.872 207.872 0 0 1-55.296-11.605334c-74.325333-23.893333-136.149333-62.378667-200.96-125.312-110.592-108.16-137.941333-216.96-142.677333-237.738666-21.418667-96 46.933333-152.192 54.698666-158.293334 10.666667-8.576 20.821333-14.08 30.293334-16.512 4.778667-1.237333 9.514667-1.834667 13.696-1.237333z" fill="#ffffff" p-id="1623"></path>
              </svg>
              {{ settings.contactNumber }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- 移动端Tab栏，仅在移动端显示 -->
    <nav class="mobile-tab" v-if="isMobile">
      <ul>
        <li>
          <router-link to="/" exact-active-class="active">
            <i class="iconfont icon-icon_857"></i>
            <span>首页</span>
          </router-link>
        </li>
        <li>
          <router-link to="/product" active-class="active">
            <i class="iconfont icon-shangpin-xianxing"></i>
            <span>产品</span>
          </router-link>
        </li>
        <!-- <li>
          <div class="tab">
            <i class="iconfont icon-caigou-xianxing"></i>
            <span>商城</span> 
          </div>
        </li> -->
         <li>
           <router-link to="/about" active-class="active">
             <i class="iconfont icon-yonghu-xianxing"></i>
              <span>关于我们</span>
           </router-link>
        </li>
        <li>
          <router-link to="/contact" active-class="active">
             <i class="iconfont icon-zaixiankefu1">
            </i>联系我们
          </router-link>
        </li>
      </ul>
    </nav>

    <div id="fkVideoBg" v-if="isVideoModalVisible" @click="toggleVideoModal(false)"></div>
    <div id="fkVideoBox" v-if="isVideoModalVisible">
      <p><span class="fkVideoClose" @click="toggleVideoModal(false)"></span></p>
      <video id="fkVideo" :src="settings.companyVideo" controls autoplay></video>
    </div>

    <div class="wxbox" v-if="isWeChatBoxVisible">
      <div class="box">
        <h2>关注我们 <a href="#" @click.prevent="toggleWeChatBox(false)" class="bd_weixin_popup_close">×</a></h2>
        <img :src="settings.wechatQrCode" width="220" height="220" alt="品牌除湿机微信公众号">
      </div>
    </div>

    <div class="diyoumask" v-if="isContactUsVisible" @click="toggleContactUs(false)"></div>
  </footer>
</template>

<script>
import { getSetting, getProductsCategory, getCaseCategory, getNewsCategory, getServiceFaqCategory } from '@/api/request';

export default {
  name: 'FooterView2',
  data() {
    return {
      isVideoModalVisible: false,
      isWeChatBoxVisible: false,
      isContactUsVisible: false,
      isMobile: false,
      settings: {
        contactNumber: '',
        domesticUrl: '',
        overseasUrl: '',
        wechatQrCode: '',
        companyVideo: '',
        copyright: ''
      },
      productCategories: [],
      caseCategories: [],
      newsCategories: [],
      faqCategories: [],
    };
  },
  methods: {
    fetchSettings() {
      getSetting().then(response => {
        const settingsData = response.list;
        this.settings.contactNumber = this.findSetting(settingsData, '联系方式').value_string;
        this.settings.domesticUrl = this.findSetting(settingsData, '国内官网地址').value_string;
        this.settings.overseasUrl = this.findSetting(settingsData, '海外官网地址').value_string;
        this.settings.wechatQrCode = this.findSetting(settingsData, '微信小程序二维码').value_url[0];
        this.settings.companyVideo = this.findSetting(settingsData, '品牌视频').value_string;
        this.settings.copyright = this.findSetting(settingsData, '版权归属').value_string;
      });
    },
    fetchAllCategories() {
      getProductsCategory().then(res => { this.productCategories = res.list.filter(cat => cat.parent_id !== 0); });
      getCaseCategory().then(res => { this.caseCategories = res.list; });
      getNewsCategory().then(res => { this.newsCategories = res.list; });
      getServiceFaqCategory().then(res => { this.faqCategories = res.list; });
    },
    findSetting(settings, name) {
      return settings.find(setting => setting.name === name) || {};
    },
    toggleVideoModal(show) {
      this.isVideoModalVisible = show;
      const videoElement = document.getElementById('fkVideo');
      if (videoElement) {
        if (show) {
          // videoElement.play(); // 浏览器可能阻止自动播放
        } else {
          videoElement.pause();
          videoElement.currentTime = 0;
        }
      }
    },
    toggleWeChatBox(show) {
      this.isWeChatBoxVisible = show;
    },
    toggleContactUs(forceState = null) {
      if (forceState !== null) {
        this.isContactUsVisible = forceState;
      } else {
        this.isContactUsVisible = !this.isContactUsVisible;
      }
    },
    openExternalLink(url) {
      window.open(url, '_blank');
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    }
  },
  mounted() {
    this.fetchSettings();
    this.fetchAllCategories();
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkMobile);
  }
};
</script>

<style scoped>
.footer-sitemap {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  margin-bottom: 15px;
}
.sitemap-column {
  flex: 1;
  min-width: 160px;
  padding: 0 15px;
}
.sitemap-column h3 {
  color: #fff;
  font-size: var(--font-size-14);
  font-weight: 600;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.sitemap-column ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.sitemap-column li {
  margin-bottom: 12px;
}
.sitemap-column a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  font-size: var(--font-size-14);
  transition: color 0.3s ease;
}
.sitemap-column a:hover {
  color: #ffffff;
  text-decoration: none;
}

.hand-cursor {
  cursor: pointer;
}
/* 原有PC端样式保持不变 */
footer .ser-twrap {}
footer .ser-twrap .tit {
  font-size: var(--font-size-14);
  color: #595757;
  line-height: 64px;
  height: 64px;
  text-align: center;
  padding-bottom: 36px;
}
footer .ser-twrap .tit span {
  color: #47975a !important;
  font-size: var(--font-size-18);
}
footer .ser-twrap .tit i {
  font-style: normal;
  color: #47975a;
  font-size: var(--font-size-18);
}
footer .fot {
  font-size: var(--font-size-14);
  border-top: 1px solid #e6e6e6;
  border-bottom: 1px solid #efefef;
}
footer .fot li {
  width: 25%;
  display: inline-flex;
  height: var(--height-175);
  text-align: center;
  vertical-align: top;
}
footer .fot li .box {
  display: block;
  margin: 40px 0 40px;
  height: 130px;
  border-left: 1px solid #e9e9e9;
  text-decoration: none;
}
footer .fot li:first-child .box {
  border-left: none;
}
footer .fot li .box img {
  width: var(--width-60);
}
footer .fot li .box .d1 {
  font-size: var(--font-size-13);
  color: #000000;
  margin-top: 16px;
}
footer .fot li .box .d2 {
  font-size: var(--font-size-13);
  color: #fff;
}
footer .fwrap {
  padding: 30px 0 12px;
  background: #47975a;
}
footer .fwrap ul {
  padding-bottom: 28px;
}
.uk-container, .m {
  max-width: var(--box2);
  margin: 0 auto;
}
* + address, * + dl, * + fieldset, * + figure, * + ol, * + p, * + pre, * + ul {
  margin-top: 0px;
}
address, dl, fieldset, figure, ol, p, pre, ul {
  margin: 0;
}
footer .fwrap li {
  float: left;
  width: 132px;
}
footer .fwrap li a {
  display: block;
  font-size: var(--font-size-10);
  line-height: 2;
  transition: all .3s ease-in;
  text-align: left;
  text-decoration: none;
}
footer .fwrap li a:first-child {
  font-size: var(--font-size-14);
}
footer .fwrap li p {
  font-size: var(--font-size-14);
  padding-bottom: 13px;
  padding-top: 15px;
}
footer .fwrap .f1 {
  font-size: var(--font-size-14);
}
footer .fwrap .f1 a {
  font-size: var(--font-size-14);
  display: inline-block;
  padding: 0 14px;
  position: relative;
  transition: all .3s ease-in;
}
footer .fwrap .f1 a:first-child {
  padding-left: 0;
}
footer .fwrap .f1 a em {
  position: absolute;
  width: 1px;
  height: 8px;
  top: 50%;
  margin-top: -4px;
  right: 0;
  background: #727171;
}
footer .fwrap .f2 .des {
  padding-top: 13px;
  line-height: 17px;
  font-size: var(--font-size-14);
}
footer .fwrap .f2 .des a {
  display: inline-block;
  height: 20px;
  vertical-align: middle;
  transition: all .3s ease-in;
}
footer .fwrap .f2 .des a:hover {
  color: #000;
}
footer .fwrap .f2 .des em {
  margin-right: 10px;
}
footer .fwrap .f2 .tel {
  line-height: 30px;
}
footer .fwrap .f2 .tel img {
  vertical-align: top;
  height: 30px;
}
footer .fwrap .f2 .tel em {
  display: inline-block;
  color: #FFF;
  font-size: var(--font-size-18);
  font-style: normal;
  font-weight: bold;
  padding-left: 28px;
  background: url('../../public/images/12.svg') no-repeat left center/22px auto;
  margin-left: 14px;
  vertical-align: top;
  font-family: 'DIN Alternate Bold';
}
footer .fwrap .f2 .tel .cn {
  font-size: var(--font-size-14);
  line-height: 30px;
  display: inline-block;
  vertical-align: top;
  padding-top: 2px;
}
footer .fwrap .f2 .tel svg {
  vertical-align: middle;
  height: 21px;
  width: 33px;
}
footer .fwrap .f2 .tel .ico {
  display: inline-block;
  width: 32px;
  height: 30px;
  background: no-repeat center/32px auto;
  vertical-align: top;
  cursor: pointer;
  transition: all .3s ease-in;
}
footer .fwrap .f2 .tel .ico:hover {
  opacity: 0.7;
}
footer .fwrap .f2 .tel .ico-wx {
  background-image: url('../../public/images/12.svg');
  margin-left: 50px;
}
footer .fwrap .f2 .tel .ico-sina {
  background-image: url('../../public/images/12.svg');
  margin-left: 16px;
}
footer .fwrap a:hover {
  color: #fff !important;
}
.hide {
  display: none;
}
#fkVideoBg {
  top: 0;
  bottom: 0;
  z-index: 101;
  background: rgba(0, 0, 0, .6);
  filter: progid:DXImageTransform.Microsoft.gradient(startcolorstr=#7F000000, endcolorstr=#7F000000) \9;
}
#fkVideoBg, #fkVideoBox {
  position: fixed !important;
  right: 0;
  left: 0;
}
#fkVideoBox {
  top: 50%;
  transform: translateY(-50%);
  margin: auto;
  width: 70%;
  max-width: 90%;
  z-index: 9999;
}

@media (max-width: 768px) {
  #fkVideoBox {
    width: 95%;
    max-width: 95%;
  }
}
#fkVideo {
  width: 100%;
  height: auto;
  display: block;
}

@media (max-width: 768px) {
  #fkVideo {
    width: 100%;
    height: auto;
  }
}
#fkVideoBox p {
  width: 100%;
  text-align: center;
  position: relative;
}
.fkVideoClose {
  position: absolute;
  top: -35px;
  right: -5px;
  z-index: 11;
  width: 30px;
  height: 31px;
  background: url('../../public/images/close.png') no-repeat;
  background-size: 100%;
  cursor: pointer;
}
.wxbox {
  width: 240px;
  text-align: center;
  position: fixed;
  top: 50%;
  left: 50%;
  margin: -132px 0 0 -120px;
  background: #fff;
  border: solid 1px #d8d8d8;
  z-index: 11001;
  font-size: var(--font-size-14);
}
.wxbox .box {
  padding: 10px;
}
.wxbox img {
  width: 100%;
}
.wxbox h2 {
  font-size: var(--font-size-14);
  color: #000;
  font-weight: bold;
  text-align: left;
  line-height: 16px;
  height: 16px;
  position: relative;
  margin-bottom: 5px;
}
.wxbox .bd_weixin_popup_close {
  width: 16px;
  height: 16px;
  position: absolute;
  right: 0;
  top: 0;
  color: #999;
  text-decoration: none;
  font-size: var(--font-size-14);
  cursor: pointer;
}
.contactusdiyou {
  position: fixed;
  bottom: 0px;
  _position: absolute;
  width: 230px;
  height: 100%;
  background: #00b3d5;
  z-index: 99999;
  color: #fff;
  transition: right .5s ease;
}
.contactusdiyou a {
  color: #fff;
}
.contactusdiyou a:hover {
  color: #333;
}
.contactusdiyou .hoverbtn {
  width: 50px;
  height: 129px;
  padding-top: 20px;
  cursor: pointer;
  position: absolute;
  top: 30%;
  margin-top: -66px;
  left: -50px;
  font-size: var(--font-size-14);
  color: #fff;
  background: #00b3d5;
  border-radius: 3px 0px 0px 3px;
}
.contactusdiyou .hoverbtn span {
  width: 50px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  overflow: hidden;
  float: left;
}
.contactusdiyou .hoverbtn .hoverimg {
  width: 13px;
  height: 9px;
  margin: 10px 0px 0px 17px;
  float: left;
  display: inline;
  background-repeat: no-repeat;
}
.contactusdiyou .conter {
  width: 186px;
  margin-left: 22px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.contactusdiyou .conter .con1 dl.ic1 dt {
  background: url('../../public/images/tel.png') no-repeat;
}
.contactusdiyou .conter .con1 dl.ic2 dt {
  background: url('../../public/images/zxkfqq.png') no-repeat;
}
.contactusdiyou .conter .con1 dl.ic3 dt {
  background: url('../../public/images/weixin.png') no-repeat;
}
.contactusdiyou .conter .con1 {
  border-bottom: 1px solid #fff;
  padding-bottom: 30px;
  margin-bottom: 30px;
}
.contactusdiyou .conter .con1 dl dt {
  padding-left: 40px;
  height: 31px;
  line-height: 31px;
  font-size: var(--font-size-14);
  color: #fff;
  font-weight: bold;
  padding-bottom: 6px;
}
.contactusdiyou .conter .con1 dl dd {
  padding-left: 40px;
}
.contactusdiyou .conter .con1 dl dd .ph_num {
  font: 18px 'Microsoft yahei';
  color: #fff;
  height: 25px;
}
.kefuQQ span.SQ a {
  background: #333;
  color: #fff;
  margin-bottom: 5px;
  display: block;
  padding: 5px;
  text-align: center;
  border-radius: 3px;
}
.kefuQQ span.SQ a:hover {
  background: #F00;
  color: #fff;
}
.diyoumask {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99998;
  width: 100%;
  height: 100%;
  opacity: 0.3;
  background: #000;
}
.uk-newvideo {
  z-index: 980;
  position: fixed;
  right: 20px;
  bottom: 20px;
  background: #fafafa;
  border: 5px solid #F2F2F2;
}
.uk-newvideo .close {
  position: absolute;
  top: -15px;
  right: -15px;
  z-index: 11;
  width: 30px;
  height: 31px;
  background: url('../../public/images/close.png') no-repeat;
  background-size: 100%;
  cursor: pointer;
}
.uk-clearfix::after {
  content: "";
  clear: both;
  display: table;
}
* {
  -webkit-text-size-adjust: none;
  text-size-adjust: none;
  margin: 0;
  padding: 0;
}
body footer a {
  color: #ffffff;
}
body footer span {
  color: #ffffff;
}
.text-center{
  text-align: center;
}
@media (max-width: 768px) {
  .footer-sitemap {
    display: none;
  }
  footer .ser-twrap .tit {
    font-size: 1rem !important;
  }
  footer .ser-twrap .tit i{
    font-size: 1rem !important;
  }
  
  .desktop-only {
    display: none;
  }
  
  .mobile-only {
    display: block;
  }
  
  .contact-info div {
    line-height: 1.5;
    padding: 2px 0;
  }
}

@media (min-width: 769px) {
  .desktop-only {
    display: block;
  }
  
  .mobile-only {
    display: none;
  }
}

</style>